/*
 * 产品字段 对应的表格单元格
 */
import Product from './product.vue';
export default Product;
